var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicianAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 11.0007C11.5307 11.0007 13.5827 8.94862 13.5827 6.41732C13.5827 3.88601 11.5307 1.83398 8.99935 1.83398C6.46804 1.83398 4.41602 3.88601 4.41602 6.41732C4.41602 8.94862 6.46804 11.0007 8.99935 11.0007Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.3327V14.666",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 20.1667C0.75 16.6192 4.17035 13.75 8.38135 13.75C9.23421 13.75 10.0604 13.8692 10.8333 14.0892",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1673 16.5007C18.1673 16.794 18.1307 17.0781 18.0573 17.3531C17.9748 17.7198 17.8281 18.0773 17.6356 18.389C17.0031 19.4523 15.839 20.1673 14.5007 20.1673C13.5565 20.1673 12.704 19.8098 12.0623 19.2231C11.7873 18.9848 11.549 18.7006 11.3657 18.389C11.0265 17.839 10.834 17.1882 10.834 16.5007C10.834 15.5107 11.2282 14.6032 11.8698 13.9432C12.539 13.2557 13.474 12.834 14.5007 12.834C15.5823 12.834 16.5631 13.3015 17.2231 14.0532C17.8098 14.704 18.1673 15.5657 18.1673 16.5007Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3327 16.5L12.666 16.5",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicianAdd);
export default __webpack_public_path__ + "static/media/technician-add.15d10c023d29dcb86c4bf83141bdf8b7.svg";
export { ForwardRef as ReactComponent };